import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	purpleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	blueLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	greenLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tealLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	yellowLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	orangeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	greyLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	darkPurpleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	darkBlueLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	darkGreenLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	darkTealLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	darkYellowLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	darkOrangeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	darkGreyLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	purpleLabel: {
		id: 'issue-epic-color.common.purple-label',
		defaultMessage: 'Purple',
		description: 'Tooltip text when hovering purple color in colour palette context menu.',
	},
	blueLabel: {
		id: 'issue-epic-color.common.blue-label',
		defaultMessage: 'Blue',
		description: 'Tooltip text when hovering blue colour palette context menu.',
	},
	greenLabel: {
		id: 'issue-epic-color.common.green-label',
		defaultMessage: 'Green',
		description: 'Tooltip text when hovering green colour palette context menu.',
	},
	tealLabel: {
		id: 'issue-epic-color.common.teal-label',
		defaultMessage: 'Teal',
		description: 'Tooltip text when hovering teal colour palette context menu.',
	},
	yellowLabel: {
		id: 'issue-epic-color.common.yellow-label',
		defaultMessage: 'Yellow',
		description: 'Tooltip text when hovering yellow colour palette context menu.',
	},
	orangeLabel: {
		id: 'issue-epic-color.common.orange-label',
		defaultMessage: 'Orange',
		description: 'Tooltip text when hovering orange colour palette context menu.',
	},
	greyLabel: {
		id: 'issue-epic-color.common.grey-label',
		defaultMessage: 'Grey',
		description: 'Tooltip text when hovering grey colour palette context menu.',
	},
	darkPurpleLabel: {
		id: 'issue-epic-color.common.dark-purple-label',
		defaultMessage: 'Dark purple',
		description: 'Tooltip text when hovering dark purple colour palette context menu.',
	},
	darkBlueLabel: {
		id: 'issue-epic-color.common.dark-blue-label',
		defaultMessage: 'Dark blue',
		description: 'Tooltip text when hovering dark blue colour palette context menu.',
	},
	darkGreenLabel: {
		id: 'issue-epic-color.common.dark-green-label',
		defaultMessage: 'Dark green',
		description: 'Tooltip text when hovering dark green colour palette context menu.',
	},
	darkTealLabel: {
		id: 'issue-epic-color.common.dark-teal-label',
		defaultMessage: 'Dark teal',
		description: 'Tooltip text when hovering dark teal colour palette context menu.',
	},
	darkYellowLabel: {
		id: 'issue-epic-color.common.dark-yellow-label',
		defaultMessage: 'Dark yellow',
		description: 'Tooltip text when hovering dark yellow colour palette context menu.',
	},
	darkOrangeLabel: {
		id: 'issue-epic-color.common.dark-orange-label',
		defaultMessage: 'Dark orange',
		description: 'Tooltip text when hovering dark orange colour palette context menu.',
	},
	darkGreyLabel: {
		id: 'issue-epic-color.common.dark-grey-label',
		defaultMessage: 'Dark grey',
		description: 'Tooltip text when hovering dark grey colour palette context menu.',
	},
});
export default messages;
